<style lang="less" scoped>
  .content{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>

<template>
  <div class="content">
			<img src="../assets/imgs/404.png"/>
		</div>
</template>

<script>
  export default {
    name:'404'
  }
</script>
